import { dummyPostCard } from "../../../constants/enums";

let initialState = {
  settingConfig: null,
  // settingConfig: {
  //   channels: [],
  //   sentiment: {
  //     positive: true,
  //     neutral: true,
  //     negative: true,
  //   },
  //   social_wall_setting: {
  //     post_presence_time: 5,
  //     post_presence_unit: "S",
  //     screen_presence_time: 1,
  //     screen_presence_unit: "M",
  //     repeat_post: {
  //       based_on_engagement: true,
  //       based_on_earliest_first: false,
  //     },
  //   },
  //   leaderboard_setting: {
  //     screen_presence_time: 1,
  //     screen_presence_unit: "M",
  //   },
  //   analytics_setting: {
  //     screen_presence_time: 1,
  //     screen_presence_unit: "M",
  //   },
  //   styling: {
  //     primary_color: "#42B549",
  //     background_color: "#000000",
  //     foreground_color: "#000000",
  //     screen_text: "",
  //     screen_sub_text: "",
  //   },
  //   brand_logo: "",
  //   screen_type: 1,
  //   ai_content: false,
  //   channel_list: [],
  // },
  settingConfigIsLoaded: false,
  mentionCardData: null,
  mentioCardLoader: false,
  leaderBoardCardData: null,
  leaderBaordLoader: false,
  analyticsData: null,
  analyticsPersistData: null,
  analyticsLoader: false,
  pauseAnimationOnAction: false,
  postModerateLoader: false,
  moderatedPostDetails: null,
};

const SocialWallScreenConfig = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_SOCIAL_WALL_SCREEN_CONFIG":
      return {
        ...initialState,
      };
    case "SETTING_CONFIG_IS_LOADED":
      return {
        ...state,
        settingConfigIsLoaded: action?.payload,
      };
    case "SET_SETTING_CONFIG":
      return {
        ...state,
        settingConfig: action?.payload,
      };
    case "SET_MENTION_LOADER":
      return {
        ...state,
        mentioCardLoader: action?.payload,
      };
    case "SET_MENTION_CARD_DATA":
      return {
        ...state,
        mentionCardData: action?.payload,
      };
    case "SET_LEADER_BOARD_LOADER":
      return {
        ...state,
        leaderBaordLoader: action?.payload,
      };
    case "SET_LEADER_BOARD_CARD_DATA":
      return {
        ...state,
        leaderBoardCardData: action?.payload,
      };
    case "SET_ANALYTICS_LOADER":
      return {
        ...state,
        analyticsLoader: action?.payload,
      };
    case "SET_ANALYTICS_DATA":
      return {
        ...state,
        analyticsData: action?.payload,
      };
    case "SET_ANALYTICS_PERSIST_DATA":
      return {
        ...state,
        analyticsPersistData: action?.payload,
      };
    case "SET_PAUSE_ANIMATION_ON_ACTION":
      return {
        ...state,
        pauseAnimationOnAction: action.value,
      };
    case "SET_POST_MODERATE_LOADER":
      return {
        ...state,
        postModerateLoader: action.value,
      };
    case "SET_MODERATE_POST_DETAILS":
      return {
        ...state,
        moderatedPostDetails: action.postDetails,
      };
    default:
      return state;
  }
};

export default SocialWallScreenConfig;
